export default {"src":"/_next/static/media/managedColocation.66472b49.svg","height":760,"width":812,"blurWidth":0,"blurHeight":0};